import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useId } from "react";

interface EmailStepProps {
	email: string;
	onEmailChange: (email: string) => void;
	onSubmit: (e: React.FormEvent) => void;
	error: string | null;
}

/**
 * This component is used to enter the email for the login process.
 * It is used in the LoginPage component.
 * @param email - The email of the user.
 */
export const EmailStep = ({
	email,
	onEmailChange,
	onSubmit,
}: EmailStepProps) => {
	const { t } = useTranslation("common");
	const emailId = useId();
	return (
		<form onSubmit={onSubmit} className="space-y-6">
			{/* Title (re-added from original to match structure slightly better, but kept simple if needed) */}
			<h1 className="text-center text-2xl font-semibold text-foreground">
				<Trans
					i18nKey="login.titleRich"
					values={{ appName: t("appName") }}
					components={{
						brand: (
							<span className="bg-gradient-to-r from-[#FFAB00] to-[#FA7A00] bg-clip-text text-transparent"></span>
						),
					}}
				/>
			</h1>
			{/* Error Display */}
			<div className="space-y-2">
				<label className="text-sm text-muted-foreground" htmlFor={emailId}>
					{t("email")}
				</label>
				<Input
					id={emailId}
					type="email"
					value={email}
					onChange={(e) => onEmailChange(e.target.value)}
					placeholder={t("emailPlaceholder")}
					className="w-full"
				/>
			</div>
			<Button type="submit" className="w-full" size="lg">
				{t("next")}
			</Button>
			<div className="text-center text-sm">
				<span className="text-muted-foreground">{t("noAccount")} </span>
				<Link to="/auth/register" className="hover:underline">
					{t("registerLink")}
				</Link>
			</div>
		</form>
	);
};
